const testimonials = [
  {
    quote:
      "They understood the story we wanted to tell before we could put it into words. Every detail, down to the last diya, felt considered.",
    names: "Amara & Rohan",
    location: "Udaipur",
    eventType: "Lakeside Wedding",
    photo: "/images/testimonials/testimonial-1.webp",
  },
  {
    quote:
      "Golden Wedding didn't just decorate our haveli — they listened to the building itself. Our guests are still talking about it.",
    names: "Meera & Arjun",
    location: "Jaipur",
    eventType: "Palace Reception",
    photo: "/images/testimonials/testimonial-2.webp",
  },
  {
    quote:
      "We handed them a beach and a sunset and trusted them completely. What they built felt like it had always belonged there.",
    names: "Isha & Vikram",
    location: "Goa",
    eventType: "Destination Wedding",
    photo: "/images/testimonials/testimonial-3.webp",
  },
  {
    quote:
      "Calm, precise, and quietly extraordinary — the way our wedding was planned was as elegant as the day itself.",
    names: "Diya & Kabir",
    location: "New Delhi",
    eventType: "Winter Wedding",
    photo: "/images/testimonials/testimonial-4.webp",
  },
];

export default testimonials;
